module.exports = __webpack_public_path__ + "img/ValueOpen.4b9ee10f.png";